// generated by @tcg/api-client gen-client — do not edit
import type { paths } from "./schema";
import { createServiceClient, type ServiceClientOptions } from "../../create-client";

export type OrdersPaths = paths;
export const ORDERS_SERVICE = "orders" as const;

/** Typed openapi-fetch client for the orders service (schema `orders`). */
export function createOrdersClient(options: ServiceClientOptions) {
  return createServiceClient<paths>("orders", options);
}

export type OrdersClient = ReturnType<typeof createOrdersClient>;
